import React from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { SERVICES } from '../data/mock';

export default function Services() {
  return (
    <main className="pt-32">
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>Wedding Services</SectionLabel>
        <Heading className="mt-5 font-serif max-w-3xl">Everything <span className="italic">wedding.</span></Heading>
        <p className="mt-6 max-w-2xl text-[#4a5c60] text-lg">Book our full planning engagement — or just the parts where you need professional support.</p>
      </section>

      <section className="max-w-[1340px] mx-auto px-6 md:px-10 pb-20">
        <div className="grid md:grid-cols-2 gap-px bg-[#e8e0d2] border border-[#e8e0d2]">
          {SERVICES.map((s, i) => (
            <div key={s.title} className="bg-[#faf4ea] p-10 group hover:bg-white transition-colors">
              <div className="flex items-start gap-6">
                <span className="font-serif text-5xl text-[#c3a66d]">{String(i+1).padStart(2,'0')}</span>
                <div className="flex-1">
                  <h3 className="font-serif text-2xl text-[#053e49]">{s.title}</h3>
                  <div className="hairline mt-3 w-16" />
                  <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-2">{s.items.map((item) => (<li key={item} className="text-[14px] text-[#4a5c60]">· {item}</li>))}</ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#053e49] text-[#faf4ea] py-24">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <SectionLabel dark>Service Marketplace</SectionLabel>
            <Heading dark className="mt-5 font-serif">Don’t need a <span className="italic text-[#ffeabf]">full wedding planner?</span></Heading>
            <p className="mt-6 text-[#d8d0bf]">No problem. Book individual Sunday Mirror wedding services for the parts where you need professional support.</p>
          </div>
          <div className="text-[#faf4ea] space-y-5">
            {[['What you need.','Photography, decor, hospitality—one service or many.'],['Where you need it.','India or international — we match destination-ready teams.'],['When you need it.','Peak season, short notice, or long-term planning.']].map(([t,s]) => (
              <div key={t} className="border-l border-[#c3a66d] pl-5">
                <div className="font-serif text-xl text-[#ffeabf]">{t}</div>
                <div className="text-sm text-[#a8b7bb] mt-1">{s}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#fbf8f2] py-24">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <SectionLabel>Sunday Mirror Rescue</SectionLabel>
          <Heading className="mt-5 font-serif">Wedding problem? <span className="italic">We may know exactly who to call.</span></Heading>
          <p className="mt-6 text-[#4a5c60] max-w-2xl">Plans change. People cancel. Unexpected situations happen. Sunday Mirror Rescue helps couples and families find professional support for urgent wedding requirements, subject to destination and team availability.</p>
          <div className="mt-8 flex flex-wrap gap-2">{['Photography','Makeup','Transport','Hospitality','Production','Coordination','And more'].map((t) => (<span key={t} className="px-3 py-1.5 text-xs border border-[#c3a66d]/50 text-[#053e49]">{t}</span>))}</div>
        </div>
      </section>

      <CTABanner />
    </main>
  );
}
